import { render, staticRenderFns } from "./epms5010.vue?vue&type=template&id=1572ec23&scoped=true"
import script from "./epms5010.vue?vue&type=script&lang=js"
export * from "./epms5010.vue?vue&type=script&lang=js"
import style0 from "./epms5010.vue?vue&type=style&index=0&id=1572ec23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572ec23",
  null
  
)

export default component.exports